var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-full-mobile is-half-tablet is-half-desktop is-half-widescreen is-one-third-fullhd"},[_c('div',{staticClass:"box has-text-centered"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }